export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "select_period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner une période"])}
      },
      "en": {
        "select_period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a period"])}
      }
    }
  })
}
